import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../types';
import { api } from '@/services/axios.helper';
import { Config } from '@ecdlink/core';
import { newGuid } from '@/utils/common/uuid.utils';

export const sendQueryErrors = createAsyncThunk<
  any,
  string,
  { state: RootState }
>('errors/sendQueryErrors', async (userId, { getState, rejectWithValue }) => {
  const state = getState() as RootState;
  const queryErrors = state.queryErrors.queryErrors;

  if (!queryErrors || queryErrors.length === 0) {
    return rejectWithValue('No errors to send');
  }

  const errorsPayload = queryErrors.map((error) => ({
    details: JSON.stringify(error),
    eventDate: new Date(error.eventDate).toISOString(),
  }));

  try {
    const accessToken = state?.auth?.userAuth?.auth_token ?? '';
    const apiInstance = api(Config.authApi, accessToken);
    const response = await apiInstance.post('/api/applog', errorsPayload);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return rejectWithValue(error.response?.data || 'Failed to send errors');
    }
    return rejectWithValue('Failed to send errors');
  }
});
